module.exports = __webpack_public_path__ + "static/media/3DPPA24.64af0adf.jpg";